<template>
	<div class="row">
		<div class="col-12" v-if="htmlText" v-html="htmlText"></div>
		<div class="col-12">
			<div class="form-group custom-form-check mt-1 mb-0 d-inline-block mr-2">
				<input id="chk-yes" class="checkbox-custom" name="chk-yes" type="checkbox" v-model="choice.checkYes" @change.prevent="cangeYes">
				<label for="chk-yes" class="checkbox-custom-label fs-0-7 xsmall-text">
					<span class="fs-0-7 bold">Sì</span>
				</label>
			</div>
			<div class="form-group custom-form-check mt-1 mb-0 d-inline-block">
				<input id="chk-no" class="checkbox-custom" name="chk-no" type="checkbox" v-model="choice.checkNo" @change.prevent="cangeNo">
				<label for="chk-no" class="checkbox-custom-label fs-0-7 xsmall-text">
					<span class="fs-0-7 bold">No</span>
				</label>
			</div>
		</div>
		<div class="col-12 fs-0-7 text-red" v-if="errorString" v-html="errorString"></div>
	</div>
</template>

<script>
export default {
	name: 'DoubleExlusiveCheckbox',
	props: {
		htmlText: {
			type: String,
			default: ''
		},
		htmlError: {
			type: String,
			default: ''
		},
		reset: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		htmlError(newVal) {
			this.errorString = newVal
		},
		reset(neVal) {
			if(neVal === true) {
				this.choice = {
					checkYes: false,
					checkNo: false
				}
			}
		}
	},
	data() {
		return {
			choice: {
				checkYes: false,
				checkNo: false
			},

			errorString: this.htmlError
		}
	},
	methods: {
		cangeYes() {
			this.errorString = ''
			if(this.choice.checkYes) {
				this.choice.checkNo = false
			}
			this.$emit('sendValues', this.choice)
		},
		cangeNo() {
			this.errorString = ''
			if(this.choice.checkNo) {
				this.choice.checkYes = false
			}
			this.$emit('sendValues', this.choice)
		}
	}
}
</script>
